export const INTERACTIVELOADED = 'interactiveLoaded';
export const PLUGINREMOVED = 'pluginRemoved';
